import { useState, useEffect } from 'react'
import { otcService } from '@/services/otcService'

export const useIndustries = () => {
  const [industries, setIndustries] = useState<string[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const loadIndustries = async () => {
      try {
        setLoading(true)
        const data = await otcService.getIndustries()
        setIndustries(data)
        setError(null)
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load industries')
        setIndustries([])
      } finally {
        setLoading(false)
      }
    }

    loadIndustries()
  }, [])

  return { industries, loading, error }
}

